import { Observable } from 'rxjs';

import { Report } from '@mirage-projects/cw-models';

export const LIMIT_TO_SHOW_CREDIT_WARNING = 60;

/**
 * Abstract service definition to manage the reports endpoints
 */
export abstract class ReportService {
    /**
     * Get the report
     */
    abstract get(): Observable<Report>;

    /**
     * Get the report by scope and user id
     * @param scope Scope of the report
     * @param userId User id of the report
     */
    abstract getByScopeAndUserId(scope: string, userId: string): Observable<Report>;
}
